<template>
	<div class="admin-box-pms">

		<InputGroup
			title="Set Surgery Date"
			desc="Please set the surgery date, all delivery of forms will be based upon this date."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>

			<InputDateTime 
				v-model="caseForm.surgery_date" 
				:darkMode="true"
				mode="date"
				:minToday="false"
				/>

		</InputGroup>

		<InputGroup
			title="Select Technical File"
			desc="Please select the technical file that this implant belongs to."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>

			<PillSelect
				title="Technical File"
				:options="techFiles"
				:singleSelectOnly="true"
				v-model="caseForm.tech_files"
				/>

		</InputGroup>

		<InputGroup
			title="Select Anatomy"
			desc="Please select the anatomy/ anatomies the device(s) in this case were implanted into."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>

			<div class="group-of-pill-selects">
				<PillSelect
					v-for="anatomyCategory in anatomiesByCategory"
					:key="anatomyCategory.category"
					:title="anatomyCategory.category"
					:options="anatomyCategory.anatomies"
					v-model="caseForm.anatomies"
					/>
			</div>

		</InputGroup>

		<InputGroup
			title="Select Other Case Features"
			desc="Please select as many of the following pathologies, Implant features that apply. This will determine what PMCF data we ask the surgeon for."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>

			<div class="group-of-pill-selects">
				<PillSelect
					v-for="featureCategory in caseFeaturesByCategory"
					:key="featureCategory.category"
					:title="featureCategory.category"
					:options="featureCategory.features"
					v-model="caseForm.case_features"
					/>
			</div>

		</InputGroup>


		

		


		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			:oneColumn="true"
			:fixedToBottom="true"
			>
			<Button
				label="Save"
				color="green"
				size="large"
				icon="save" 
				@click="submitPMSSettings"
				:disabled="!canSave"
				/>
		</InputGroup>


	</div>
</template>

<script>


import InputGroup from "@/Components/InputGroup"
import InputText from "@/Components/InputText"
import InputTextarea from "@/Components/InputTextarea"
import InputDateTime from "@/Components/InputDateTime"
import InputFancyRadio from "@/Components/InputFancyRadio"
import Button from "@/Components/Button"
import PillSelect from "@/Components/PillSelect"

export default {
	props: {
		thisCase: {
			type: Object,
			required: true
		},
		anatomies: {
			type: [Array, Boolean],
			required: false,
			default: false
		},
		techFiles: {
			type: [Array, Boolean],
			required: false,
			default: false
		},
		caseFeatures: {
			type: [Array, Boolean],
			required: false,
			default: false
		},
	},
	components: {
		InputGroup,
		InputText,
		InputTextarea,
		InputDateTime,
		InputFancyRadio,
		Button,
		PillSelect
	},
	data: () => {
		return {
			caseForm: {
				surgery_date: '', // YYYY-MM-DD
				tech_files: [],
				anatomies: [],
				case_features: []
			},
		}
	},
	mounted(){
		this.caseForm.surgery_date = this.thisCase.surgery_date

		// just extract the id's from the arrays
		if(this.thisCase.technical_files.length > 0){
			this.caseForm.tech_files = this.thisCase.technical_files.map(techFile => techFile.id)
		}
		if(this.thisCase.anatomies.length > 0){
			this.caseForm.anatomies = this.thisCase.anatomies.map(anatomy => anatomy.id)
		}
		if(this.thisCase.case_features.length > 0){
			this.caseForm.case_features = this.thisCase.case_features.map(feature => feature.id)
		}

		// console.log('pms data', {
		// 	anatomies: this.anatomies,
		// 	techFiles: this.techFiles,
		// 	caseFeatures: this.caseFeatures
		// })
		console.log('project', this.thisCase)
	},
	methods: {
		submitPMSSettings(){
			if(this.canSave){
				this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/pms-settings`, this.caseForm)
			}
		},
	},
	computed: {
		canSave(){

			if(this.caseForm.surgery_date == '' || this.caseForm.surgery_date == null){
				return false
			}

			return true
		},
		anatomiesByCategory(){
			let categories = []

			this.anatomies.forEach(anatomy => {
				if(!categories.includes(anatomy.category)){
					categories.push(anatomy.category)
				}
			})

			let sortedAnatomies = []

			categories.forEach(category => {
				let categoryAnatomies = this.anatomies.filter(anatomy => anatomy.category == category)
				sortedAnatomies.push({
					category: category,
					anatomies: categoryAnatomies
				})
			})

			return sortedAnatomies
		},
		caseFeaturesByCategory(){
			let categories = []

			this.caseFeatures.forEach(feature => {
				if(!categories.includes(feature.category)){
					categories.push(feature.category)
				}
			})

			let sortedFeatures = []

			categories.forEach(category => {
				let categoryFeatures = this.caseFeatures.filter(feature => feature.category == category)
				sortedFeatures.push({
					category: category,
					features: categoryFeatures
				})
			})

			return sortedFeatures
		}
	}
}

</script>

<style scoped lang="sass">

.admin-box-pms
	.group-of-pill-selects
		display: flex
		flex-direction: column
		gap: 10px



</style>